import { useState, useEffect } from 'react';
import { useVerifyCodeStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { ErrorMasterKeyModal } from './widgets';
import { Footer } from '@widgets/footer';
import { Button, CodeInput } from '@shared/widgets';
import bgImg from '@assets/images/auth/bg-01.png';

export const RegisterCodePage = () => {
  const verifyCodeStore = useVerifyCodeStore();
  const { navigate } = useRouteHook();

  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState('');
  const [, setErrorValidate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorCount, setErrorCount] = useState(0);

  useEffect(() => {
    if (verifyCodeStore.success !== null && verifyCodeStore.success !== undefined) {
      navigate(RoutePaths.registerOk.onNavigate());
    }
  }, [verifyCodeStore.success]);

  const validateField = (fieldName: string, value: string) => {
    let error = false;
    let text = '';

    switch (fieldName) {
      case 'code':
        if (value.length !== 6) {
          text = 'incorrect code';
          error = true;
        }
        setCodeError(text);
        break;
    }

    setErrorValidate(error);

    return !error;
  };

  const sendForm = () => {
    if (validateField('code', code)) {
      setLoader(true);
      verifyCodeStore.verifyCode({ code });
    }
  };

  return (
    <>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className='relative z-[99] h-[702px] w-full bg-right bg-no-repeat pl-[150px] text-left max-md:h-auto max-md:!bg-none max-md:pt-0 max-md:pl-0'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='w-[590px] max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12'>
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>Registration</h2>
            <p className='mt-7.5 w-[394px] text-center text-lg font-medium text-[#000000]'>
              Master Key has generated a one-time confirmation code, please insert it below to login.
            </p>
            <div className='mt-4 w-[294px] text-center max-md:w-full'>
              <CodeInput isFocus onComplete={setCode} />
              {verifyCodeStore.error && codeError && (
                <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{verifyCodeStore.error}</div>
                </div>
              )}
              <div className='mt-4 cursor-pointer text-xs font-medium text-[#272727] uppercase max-md:normal-case'>
                Problems with my Master Key code
              </div>
            </div>
            <Button className='mt-5 w-[292px] max-md:mt-8 max-md:w-full' isLoading={loader} onClick={sendForm}>
              Submit
            </Button>
          </div>
        </div>
      </div>
      {/* TODO: NOT WORKING BEFORE */}
      <ErrorMasterKeyModal isOpen={errorCount >= 3} onClose={() => setErrorCount(0)} />
      <Footer />
    </>
  );
};
